export default __webpack_public_path__ + "static/careers-benefits-block1-icon06.url-bba87d5066049b645ecbcbe9a6b9a226.svg";